import React, { useState} from "react";
import './index.css';
import { Link } from 'react-router-dom';
import Home  from './View//Home';
import LoginForm from "./View/Login";
import RegisterForm from "./View/Register";
import {BrowserRouter,Route, Switch, Redirect } from 'react-router-dom';
import NavBar from "./View/component/navbar";
import Footer from "./View/component/piepagina";
import HomeClient from "./View/InicioCliente";
import HomeTutor from "./View/InicioTutor";
import Contenido from "./View/Contenido";
import Tutores from "./View/Tutores";
import detalleContenido from "./View/DetalleContenido";
import detalleTutor from "./View/DetalleTutor";
import compras from "./View/Compras";
import ventas from "./View/Ventas";
import detalleCompra from "./View/DetalleCompra";
import ListarContenido from "./View/ListarContenido";
import mensajes from "./View/Mensajes";
import SubirContenido from "./View/SubirContenido";
import ListarSesiones from "./View/ListarSesiones";
import SubirSesiones from "./View/SubirSesiones";
import configPerfil from "./View/ConfiguracionPerfil";
import paginaPago from "./View/Pago";
import { ProveedorCarrito } from "./View/component/Cart";
import FinalizarPago from "./View/FinalizarPago";
import PagoExitoso from "./View/PagoExitoso";
import SubscripcionSuccess from "./View/SubscripcionSuccess";
import CancelarPagoSubscripcion from "./View/CancelarPago";
import HomeAdmin from "./View/Administracion";
import olvidoContrasenna from "./View/OlvidoContraseña";
import ReestablecerContraseña from "./View/ReestablecerContraseña";
import { QuienesSomos, PlanesPrecios, ContactaConNosotros, Terminos, Privacidad, Seguridad, Cookies } from './View/component/piepagina';



// Al cargar la app, leemos si había un tema guardado
const savedTheme = localStorage.getItem('app-theme');
const initialTheme = savedTheme === null ? 'dark' : savedTheme;

if (initialTheme === 'dark') {
  document.documentElement.classList.add('dark-mode');
} else {
  document.documentElement.classList.add('light-mode');
}

const PrivateRoute = ({ component: Component, usuario, allowedTypes, ...rest }) => {
  return(
    <Route
      {...rest}
      render = {props => 
        usuario && allowedTypes.includes(usuario.Tipo) ? (
          <Component {...props} />
        ) : (
          <Redirect to={{
            pathname: '/login',
            state: { from: props.location }
          }} />
        )
      }
    />
  );
};

const App = () => { 

  // Obtener el usuario logueado desde el localStorage
  const [usuario, setUsuario] = useState(() => {
    const usuarioAlmacenado = localStorage.getItem('userLogueado');
    return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
  });

  
   
  return (
    <div>
      <ProveedorCarrito>
        <BrowserRouter>
          <NavBar />

          <Switch>
          {/*Ruta de inicio. Dependiendo de si hay usuario, el tipo o si no lo hay*/}
          <Route exact path="/">
              {
                usuario ? ( // Si hay usuario logueado, redirigir según su tipo
                  usuario.Tipo === "Cliente" 
                  ? (<Redirect to="/cliente" />) : (usuario.Tipo === "Tutor") ? (<Redirect to="/tutor" />) : (<Redirect to="/admin" />)
                ) : (
                  <Home /> // Si no hay usuario, mostrar la página de inicio general
                )
              }
            </Route>

            {/*Rutas públicas*/}
            <Route exact path='/login' render={props =>
              usuario ? (
                // Si ya hay usuario al entrar a /login, lleva a su página de inicio
                <Redirect to={usuario.Tipo === 'Cliente' ? '/cliente' : usuario.Tipo === 'Tutor' ? '/tutor' : '/admin'} />
              ) : (
                // Si no, pasamos setUsuario para que LoginForm actualice el state
                <LoginForm {...props} setUsuario={setUsuario} />
              )
            }/>
            <Route exact path='/register' component={RegisterForm} />
            <Route exact path='/contenido' component={Contenido} />
            <Route exact path='/tutores' component={Tutores} />
            <Route exact path='/detalleContenido/:id' component={detalleContenido} />
            <Route exact path='/detalleTutor/:id' component={detalleTutor} />
            <Route path="/SubscripcionSuccess" component={SubscripcionSuccess} />
            <Route path="/CancelarPagoSubscripcion" component={CancelarPagoSubscripcion} />
            <Route path="/OlvidoSuContraseña" component={olvidoContrasenna} />
            <Route path="/ReestablecerContrasenna" component={ReestablecerContraseña} />
            <Route exact path="/quienes-somos" component={QuienesSomos} />
            <Route exact path="/planesPrecios" component={PlanesPrecios} />
            <Route exact path="/contacta" component={ContactaConNosotros} />
            <Route exact path="/terminos" component={Terminos} />
            <Route exact path="/privacidad" component={Privacidad} />
            <Route exact path="/seguridad" component={Seguridad} />
            <Route exact path="/cookies" component={Cookies} />

            {/*Rutas privadas */}
            <PrivateRoute exact path='/cliente' component={HomeClient} usuario={usuario} allowedTypes={['Cliente']} />
            <PrivateRoute exact path='/tutor' component={HomeTutor} usuario={usuario} allowedTypes={['Tutor']}/>
            <PrivateRoute exact path='/admin' component={HomeAdmin} usuario={usuario} allowedTypes={['Administrador']}/>
            <PrivateRoute exact path='/compras' component={compras} usuario={usuario} allowedTypes={['Cliente']}/>
            <PrivateRoute exact path='/mensajes' component={mensajes} usuario={usuario} allowedTypes={['Cliente', 'Tutor', 'Administrador']}/>
            <PrivateRoute exact path='/ventas' component={ventas} usuario={usuario} allowedTypes={['Tutor']}/>
            <PrivateRoute exact path='/detallesCompra/:id' component={detalleCompra} usuario={usuario} allowedTypes={['Cliente']}/>
            <PrivateRoute exact path='/listarContenido' component={ListarContenido} usuario={usuario} allowedTypes={[ 'Tutor' ]}/>
            <PrivateRoute exact path='/subirContenido' component={SubirContenido} usuario={usuario} allowedTypes={[ 'Tutor' ]}/>
            <PrivateRoute exact path='/listarSesiones/:id' component={ListarSesiones} usuario={usuario} allowedTypes={[ 'Tutor' ]}/>
            <PrivateRoute exact path='/subirSesiones' component={SubirSesiones} usuario={usuario} allowedTypes={[ 'Tutor' ]}/>
            <PrivateRoute exact path='/configurarPerfil' component={configPerfil} usuario={usuario} allowedTypes={['Cliente', 'Tutor', 'Administrador']}/>
            <PrivateRoute exact path='/pago' component={paginaPago} usuario={usuario} allowedTypes={['Cliente']}/>
            <PrivateRoute exact path='/success' component={FinalizarPago} usuario={usuario} allowedTypes={['Cliente']}/>
            <PrivateRoute exact path='/compra/exitosa/:compraId' component={PagoExitoso} usuario={usuario} allowedTypes={['Cliente']}/>
            <PrivateRoute exact path='/pago/error' usuario={usuario} allowedTypes={['Cliente']} render={() => (
              <div>
                <h2>Error al procesar el pago</h2>
                <Link to="/">Volver al inicio</Link>
              </div>
            )}/>


          </Switch>
          
          <Footer />
        </BrowserRouter>
      </ProveedorCarrito>
    </div>
  );
}

export default App;



                        

                        